.btn-scroll-to-top {
  display: none;
  position: fixed;
  bottom: 90px;
  right: 22px;
  height: 50px;
  width: 50px;
  border: solid 1px #fff;
  border-radius: 50%;
  background-color: #FFF;
  transform: translateY(0);
  box-shadow: 0px 3px 9px rgba(0, 0, 0, 0.16);
  @include transitionDefault(all);
  z-index: 100;

  .svg-icon {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);

    svg {
      @include svg-format(15px, 15px, $primary);
      @include transitionDefault(fill);
    }
  }

  &:hover,
  &:focus {
    transform: translateY(-5px);
    @include transitionDefault(all);

    .svg-icon {
      svg {
        fill: $secondary;
        @include transitionDefault(fill);
      }
    }
  }
}